import { doRequest, REQUEST_METHODS } from './base'

export const getProduct = async (id: string): Promise<GetProductResponse> => {
  return await doRequest(REQUEST_METHODS.GET, `/api/products/${id}`)
}

export default {
  getProduct
}
